import { Box } from '@mui/material';

import type { ActionsComponent } from './types';
import CbButton from '../../../components/Buttons/CbButton';

export const DefaultActions: ActionsComponent = (props) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" mt="24px">
      <CbButton
        styleName="cancel"
        disabled={!props.formMethods.formState.isDirty}
        onClick={() => props.formMethods.reset()}
      >
        Cancel
      </CbButton>

      <CbButton
        styleName="ctaButton"
        type="submit"
        disabled={
          props.formMethods.formState.isSubmitting ||
          !props.formMethods.formState.isDirty
        }
        loading={props.formMethods.formState.isSubmitting}
      >
        Save
      </CbButton>
    </Box>
  );
};
